import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type { FinanceSalesResponse } from "./sales-types";

export async function fetchFinanceSales(
  range: FinanceDateRangeValue,
  page = 1,
  shipmentPage = 1,
  search = "",
  sort: "gross_profit" | "net_sales" | "gross_margin" = "gross_profit",
  groupBy: "class" | "category" | "product" = "class",
  classIds: number[] = [],
  categoryIds: number[] = [],
  productIds: number[] = [],
  customerIds: number[] = [],
  currencyIds: number[] = [],
  profitabilityStatuses: Array<
    "profitable" | "unprofitable" | "missing_costs"
  > = [],
): Promise<FinanceSalesResponse> {
  const response = await axiosApiInstance.get<FinanceSalesResponse>(
    "finance/sales",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        shipment_page: shipmentPage,
        search: search || undefined,
        sort,
        group_by: groupBy,
        class_ids: classIds.length ? classIds : undefined,
        category_ids: categoryIds.length ? categoryIds : undefined,
        product_ids: productIds.length ? productIds : undefined,
        customer_ids: customerIds.length ? customerIds : undefined,
        currency_ids: currencyIds.length ? currencyIds : undefined,
        profitability_statuses: profitabilityStatuses.length
          ? profitabilityStatuses
          : undefined,
        direction: "desc",
      },
    },
  );

  return response.data;
}
